module.exports = __webpack_public_path__ + "static/media/Reloj.a1f927e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Reloj.svg
// module id = 2066
// module chunks = 0